/*
----- Sections ----- 
Axis toggler is build on top of Foundation's Toggler https://get.foundation/sites/docs/toggler.html but adds a few addtional features:
- Breakpoint support, trigger functionality on specific breakpoint.
- Automatically assign a section heading to be used ( kinda like an accordion )

*/

var instances = {};

function getInstanceId(context) {
    if (!context) {
        AXISDebug.output(3,"Barcode Scanner: No context provided");
        return false;
    }
    let id = context.attr(expressSelectors()['sections']['initialise']);
    if (!id) {
        // Find closest.
        id = context.closest('[' + expressSelectors()['sections']['initialise'] + ']').attr(expressSelectors()['sections']['initialise']);
        if (!id) {
            AXISDebug.output(3,"Sections: No Id found, has this element been initialised?");
            return false;
        }
    } 
    return id;
}

// Instances get / set functions.
function setContext(id, value) {
    instances[id]['context'] = value;
    return instances[id]['context'];
}
function getContext(id) {
    return instances[id]['context'];
}
function setBreakpoint(id, value) {
    instances[id]['breakpoint'] = value;
    return instances[id]['breakpoint'];
}
function getBreakpoint(id) {
    return instances[id]['breakpoint'];
}
function setHeaderContext(id, value) {
    instances[id]['header-context'] = value;
    return instances[id]['header-context'];
}
function getHeaderContext(id) {
    return instances[id]['header-context'];
}
function setContentContext(id, value) {
    instances[id]['content-context'] = value;
    return instances[id]['content-context'];
}
function getContentContext(id) {
    return instances[id]['content-context'];
}
function setButtonsContext(id, value) {
    return instances[id]['buttons-context'] = value; 
}
function getButtonsContext(id) {
    return instances[id]['buttons-context'];
} 

function initialiseAll() {
    // Get all elements.
    let elements = $('[' + expressSelectors()['sections']['initialise'] + ']');
    // Loop through instances;
    elements.each(function() {
        // Grab context.
        let context = $(this);
        // Initialise.
        let init = initialise(context);
    });

    // Responsive listener.
    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
        $.each(instances, function(key, value) {
            // Get instance id.
            let id = key;
            // Get breakpoint.
            let breakpoint = getBreakpoint(id);
            // If breakpoint defined check whether we need to enable or disable section.
            if (breakpoint) {
                // Attempting to simplify this process.
                sectionEnable(id);

                // if (Foundation.MediaQuery.is(breakpoint) && !Foundation.MediaQuery.is(oldSize)) {
                //     sectionEnable(id);
                // } else if (!Foundation.MediaQuery.is(breakpoint) && Foundation.MediaQuery.is(newSize)) {
                //     sectionEnable(id);
                // } else {
                //     if (AXISDebug.level() >= 3) {
                //         AXISDebug.output(1,"Sections: Disabling reveal due to breakpoint configuration", id);
                //     }
                //     sectionDisableReveal(id)
                // }
            }
        });       
    });
}

function initialise(context) {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Sections: Attempting to initialise section", context);
    }

    // TODO: clean up instances that dont exist anymore due to content being replaced by ajax.

    let id = context.attr(expressSelectors()['sections']['initialise']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['sections']['initialise'], generateId());
        id = context.attr(expressSelectors()['sections']['initialise']);
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Sections: Instance already initialised skipping.");
        }
        return false;
    }
    // Add section class.
    context.addClass('axis-section');
    // Config.
    // Find the header.
    let header = context.find('[' + expressSelectors()['sections']['header'] + ']');
    if (header == 0) {
        AXISDebug.output(2,"Sections: Header not defined", context);
    }
    // Find content.
    let content = context.find('[' + expressSelectors()['sections']['content'] + ']');
    if (content.length == 0) {
        AXISDebug.output(2,"Sections: Couldn't find content", context);
    }
    // Optional on what breakpoint(s) should this work.
    let breakpoint = context.attr(expressSelectors()['sections']['breakpoint']);
    // Button container.
    const buttons = context.find('[' + expressSelectors()['sections']['buttons'] + ']');
    // If disabled then get reason.
    const disabledReason = context.attr(expressSelectors()['sections']['disabled-reason']);

    // Add config to instance.
    setContext(id, context);
    setHeaderContext(id, header);
    setBreakpoint(id, breakpoint);
    setContentContext(id, content);
    setButtonsContext(id, buttons);
    // Enable section ( basically add classes ).
    sectionEnable(id);

    // Toggle on page initialise.
    let openOnLoad = (context.attr(expressSelectors()['sections']['open-on-load']) != undefined);
    if (openOnLoad) {
        if (AXISDebug.level() >= 4) {
            AXISDebug.output(1,"Sections: Opening section on initialisation.", context);
        }
        sectionToggle(id);
    }

    // --- Add listeners ---
    // Click.
    header.on('click', function() {
        // Check if disabled.
        const isDisabled = context.hasClass('disabled');
        // If not disabled then toggle.
        if (!isDisabled) {
            sectionToggle(id);
        } else {
            if (disabledReason) {
                callouts.create(disabledReason, 1);
            } else {
                AXISDebug.output(2,"Sections: Section disabled but no reason provided");
            }
        }
    });
}

function sectionEnable(id) {
    // Get context.
    let context = getContext(id);
    // Get header.
    let header = getHeaderContext(id);
    // Get content.
    let content = getContentContext(id);
    // Get breakpoint.
    let breakpoint = getBreakpoint(id);
    // Get buttons.
    const buttons = getButtonsContext(id);
    // Find out if breakpoint is active, default to true if no breakpoint specified.
    let isBreakpointActive = (breakpoint ? Foundation.MediaQuery.is(breakpoint) : true);
    // If active then add classes.
    if (isBreakpointActive) {
        header.addClass('axis-section-header');
        content.addClass('axis-section-content');
        context.addClass("reveal-enabled");
        buttons.addClass('axis-section-buttons');
    } else {
        if (header.hasClass('axis-section-header')) {
            header.removeClass('axis-section-header');
        }
        if (content.hasClass('axis-section-content')) {
            content.removeClass('axis-section-content');
        }
        sectionDisableReveal(id);
    }
}

function sectionDisableReveal(id) {
    // Get context.
    let context = getContext(id);
    if (!context) {
        AXISDebug.output(3,"Sections: Cannot disable reveal as no context passed in.", context);
        return false;
    }
    if (context.hasClass('reveal-enabled')) {
        context.removeClass('reveal-enabled');
    }

}

function sectionToggle(id) {
    // Get context.
    let context = getContext(id);
    // Check if active.
    let isActive = context.hasClass('active');
    if (isActive) {
        context.removeClass('active');
        closeSection(id);
    } else {
        openSection(id);
    }
}

// Open a section and remove disabled state if appled.
function openSection(id) {
    const context = getContext(id);
    context.addClass('active');
    // Check if section is disabled.
    const isDisabled = context.hasClass('disabled');
    if (isDisabled) {
        context.removeClass('disabled');
    }
    return {
        'success': true,
        'id': id
    }
}

// Close section.
function closeSection(id) {
    const context = getContext(id);
    context.removeClass('active');
    return {
        'success': true,
        'id': id
    }
}

var sections = $.sections = {
    initialise: (context) => {
        return initialise(context);
    }, 
    initialiseAll: () => {
        return initialiseAll();
    },
    open: (context) => {
        const id = getInstanceId(context);
        if (id) {
            return openSection(id);
        } else {
            return false;
        }
    }
}

export { sections }